import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: false,
  selector: "app-finish-quiz-modal",
  templateUrl: "./finish-quiz-modal.component.html",
  styleUrls: ["./finish-quiz-modal.component.scss"],
})
export class FinishQuizModalComponent implements OnInit {
  quizScore: number;
  quizQuestionCount: number;
  message: string;
  percentage: number;
  isStudent: boolean;
  topicId: number;
  lessonId: number;
  correctAnswers: number = 0;

  constructor(private router: Router, private modal: NgbModal) { }

  ngOnInit(): void {
  }

  continueLearning(): void {
    this.modal.dismissAll();
    if (this.isStudent) {
      if (this.lessonId) {
        // Lesson-based quiz - navigate to specific lesson
        this.router.navigate(["/dashboard/video-player"], {
          queryParams: { lessonId: this.lessonId },
        });
      } else if (this.topicId) {
        // Topic-based quiz (brainshaker,testout) - navigate to video player with topicId
        this.router.navigate(["/dashboard/video-player"], {
          queryParams: { topicId: this.topicId },
        });
      } else {
        // Fallback to dashboard
        this.router.navigate(["/dashboard/student"]);
      }
    } else {
      this.router.navigate(["/learn/subjects"]);
    }
  }
  reviewQuiz(): void {
    this.modal.dismissAll();
  }
  retryQuiz(): void {
    window.location.reload();
  }
}
